import { useEffect } from 'react';
import { useStarData } from './useStarData';

/**
 * Hook that performs daily reset checks on component mount
 * This ensures that daily tasks, rewards, and streaks are properly reset
 * when a new day has started.
 */
export const usePageLoadResetCheck = () => {
  const { performPageLoadResets } = useStarData();

  useEffect(() => {
    // Perform reset check on mount
    performPageLoadResets();
    // Empty deps array ensures this only runs once on mount, not on every function reference change
    // This is intentional as we want page-load behavior, not reactive updates
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
